<template>
	<v-dialog v-model="dialogVideo" max-width="800px" persistent>
		<v-card>
			<v-card-title class="mb-4">
				<span class="headline">Cadastrar</span>
				<v-spacer></v-spacer>
				<v-btn
					small
					outlined
					@click="archiveChoice()"
					title="Para enviar os arquivos através de FTP"
				>
					Pré-cadastro
				</v-btn>
			</v-card-title>
			<v-card-text v-if="progress">
				<h2 class="text-center">Não saia desta página até o fim do envio</h2>
				<v-progress-linear
					color="light-blue"
					height="25"
					:value="uploadPercentage"
					rounded
					striped
					reactive
				>
					<template v-slot="{ value }">
						<strong>{{ Math.ceil(value) }}%</strong>
					</template>
				</v-progress-linear>
			</v-card-text>

			<v-card-text>
				<v-form ref="form">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-file-input
									v-model="editedItem.video"
									label="Selecione um vídeo"
									accept="video/mp4,video/ogg,video/webm"
									show-size
								></v-file-input>
								<!-- <v-radio-group v-model="editedItem.resolucao">
									<v-radio label="480p" :value="480"></v-radio>
									<v-radio label="720p" :value="720"></v-radio>
									<v-radio label="1080p" :value="1080"></v-radio>
								</v-radio-group> -->
							</v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>

			<v-divider></v-divider>
			
			<v-simple-table v-if="videos" dense>
				<template v-slot:default>
					<tbody>
						<tr v-for="video in videos" :key="video.id">
							<th class="text-left">Vídeo</th>
							<td>{{ video.file }}</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="warning" icon @click="close()" title="Fechar formulário">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
				<v-btn color="success" icon @click="save()" title="Salvar formulário">
					<v-icon>fal fa-save</v-icon>
				</v-btn>
			</v-card-actions>
			<OpenChoice :choice="choice" @choiceResult="choiceResult" />
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

import OpenChoice from '@/components/OpenChoice'

export default {
	inheritAttrs: false,
	components: {
		OpenChoice,
	},
	props: {
		aulaId: null,
	},

	data() {
		return {
			server: 'video',
			editedItem: {
				id: 0,
				video: undefined,
				resolucao: 720,
			},
			progress: false,
			uploadPercentage: 0,
			videos: [],
			choice: {
				title: 'Você tem certeza?',
				dialog: false,
			},
		}
	},
	computed: {
		...mapState(['user', 'rules', 'dialogVideo']),
	},
	created() {
		this.getData()
	},
	methods: {
		archiveChoice() {
			this.choice.dialog = true
		},
		choiceResult(value) {
			if (value === true) {
				this.preCadastro()
			} else {
				this.$store.dispatch('alert', {
					alertMessage: 'Solicitação cancelada',
					alertType: 1,
				})
			}
		},
		preCadastro() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'insert_pre_cadastro_' + this.server)
			formData.append('user_id', this.user.id)
			formData.append('aula_id', this.aulaId)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.$store.dispatch('searchAula', { value: true })
						vd.$store.dispatch('alert', {
							alertMessage: response.data.alertMessage,
							alertType: 0,
						})
						vd.close()
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destination: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERROR!! ' + response)
				})
		},

		getData() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_' + this.server)
			formData.append('user_id', this.user.id)
			formData.append('aula_id', this.aulaId)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.videos = response.data.videos
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},

		close() {
			this.$store.dispatch('dialogVideo', { value: false })
			setTimeout(() => {
				this.$emit('changeTypeForm', { typeForm: 0, hideForm: 'video' })
			}, 300)
		},

		save() {
			if (this.editedItem.video == undefined) {
				this.$store.dispatch('alert', {
					alertMessage: 'Selecione um vídeo',
					alertType: 1,
				})
			} else {
				this.progress = !this.progress

				let formData = new FormData()
				formData.append('menu', 'send_' + this.server)
				formData.append('function', 'insert_send_' + this.server)
				formData.append('user_id', this.user.id)
				formData.append('aula_id', this.aulaId)
				formData.append('video', this.editedItem.video)
				formData.append('resolucao', this.editedItem.resolucao)
				let vd = this
				this.$axiosPost
					.post('functions.php', formData, {
						headers: { Authorization: this.user.token },
						onUploadProgress: function(progressEvent) {
							vd.uploadPercentage = parseInt(
								Math.round((progressEvent.loaded / progressEvent.total) * 100)
							)
						}.bind(vd),
					})
					.then(function(response) {
						if (response.data.error === 0) {
							vd.$store.dispatch('searchAula', { value: true })
							vd.$store.dispatch('alert', {
								alertMessage: response.data.alertMessage,
								alertType: 0,
							})
							vd.close()
						} else {
							vd.$store.dispatch('errorServer', {
								data: response.data,
								destination: vd.$route.path,
							})
						}
					})
					.catch(function(response) {
						console.log('ERROR!! ' + response)
					})
			}
		},
	},
}
</script>
